import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { tap, take, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/global/services/message/message.abstract.service';
import { State } from 'src/app/store';
import { isAuthenticatedSelector, isAdminSelector } from '../store/auth.selectors';

@Injectable()
export class AuthGuard implements CanActivate {
    public t: any = {};

    constructor(
        public store: Store<State>,
        public router: Router,
        public messageService: MessageService,
        public translateService: TranslateService,
    ) {
        this.translateService
            .get('common.errors')
            .pipe(tap((t) => (this.t = t)))
            .subscribe();
    }

    canActivate(): Observable<boolean> {
        return combineLatest([this.store.select(isAuthenticatedSelector), this.store.select(isAdminSelector)]).pipe(
            take(1),
            tap(([isAuth]) => {
                if (!isAuth) {
                    this.router.navigate(['/login']);
                }
            }),
            tap(([, isAdmin]) => {
                if (isAdmin === undefined) {
                    this.router.navigate(['/login']);
                } else if (isAdmin === false) {
                    this.messageService.error(this.t.notAllowed);
                    this.router.navigate(['/login']);
                }
            }),
            map(([isAuth, isAdmin]) => !!isAuth && !!isAdmin),
        );
    }
}
